import { render, staticRenderFns } from "./tutorial-official.vue?vue&type=template&id=754c8a22&"
import script from "./tutorial-official.vue?vue&type=script&lang=js&"
export * from "./tutorial-official.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports